import React from "react";
import { Box, Chip } from "@mui/material";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { formatFileSize } from "../../../util/numberFormat";

// 이 모듈이 내부에서도 쓰고 외부로도 노출한다 — 재수출(export … from)은 로컬 바인딩을 안 만들어서 import + export 로 나눈다.
export { formatFileSize };

/**
 * 채널 업무(ProjectTaskTab / TaskDetailModal) 공용 상수·헬퍼.
 * 상태 라벨/칩, 파일 아이콘/사이즈, 첨부 칩을 한 곳에서 관리한다.
 */

export const STATUS_LABELS = {
    REVIEW_REQUEST: { label: "검토 요청", color: "#f59e0b", bg: "#fef3c7" },
    STARTED: { label: "시작", color: "#3b82f6", bg: "#eff6ff" },
    IN_PROGRESS: { label: "진행 중", color: "#2563eb", bg: "#eff6ff" },
    DONE: { label: "완료", color: "#10b981", bg: "#ecfdf5" },
    OVERDUE: { label: "마감 초과", color: "#ef4444", bg: "#fef2f2" },
};

// 사용자가 직접 선택 가능한 상태 순서 (OVERDUE 는 기한에 따라 자동 표시라 제외).
export const SELECTABLE_STATUSES = ["STARTED", "IN_PROGRESS", "REVIEW_REQUEST", "DONE"];

/**
 * 역할별로 지정 가능한 상태 목록.
 *  - 지시자(createdBy): 전부(승인=완료, 반려=진행 중).
 *  - 담당자(assignee): 시작·진행 중·검토 요청까지 (완료는 지시자만).
 *  - 지시자 정보가 없는 레거시 업무는 멤버 누구나 전부 허용.
 */
export function allowedStatuses({ isCreator, isAssignee, legacyNoCreator }) {
    if (isCreator || legacyNoCreator) return SELECTABLE_STATUSES;
    if (isAssignee) return ["STARTED", "IN_PROGRESS", "REVIEW_REQUEST"];
    return [];
}

export function StatusChip({ status, size = "small" }) {
    const s = STATUS_LABELS[status] || STATUS_LABELS.STARTED;
    return (
        <Chip
            label={s.label}
            size={size}
            sx={{ bgcolor: s.bg, color: s.color, fontWeight: 700, fontSize: 11, border: `1px solid ${s.color}33` }}
        />
    );
}

export function fileIcon(contentType) {
    if (!contentType) return <InsertDriveFileRoundedIcon sx={{ color: "#6b7280" }} />;
    if (contentType.includes("pdf")) return <PictureAsPdfRoundedIcon sx={{ color: "#ef4444" }} />;
    if (contentType.startsWith("image/")) return <ImageRoundedIcon sx={{ color: "#3b82f6" }} />;
    return <InsertDriveFileRoundedIcon sx={{ color: "#6b7280" }} />;
}


export function AttachmentChip({ attachment, editable, onDelete }) {
    if (editable) {
        return (
            <Chip
                icon={<Box sx={{ display: "flex", fontSize: 16 }}>{fileIcon(attachment.contentType)}</Box>}
                label={attachment.originalFileName || attachment.name}
                size="small"
                onDelete={onDelete}
                sx={{ maxWidth: 220, fontSize: 11, bgcolor: "#f1f5f9", border: "1px solid #e2e8f0" }}
            />
        );
    }
    return (
        <Box component="a" href={attachment.fileUrl} target="_blank" sx={{ textDecoration: "none" }}>
            <Chip
                icon={<Box sx={{ display: "flex", fontSize: 16 }}>{fileIcon(attachment.contentType)}</Box>}
                label={`${attachment.originalFileName} (${formatFileSize(attachment.fileSize)})`}
                size="small"
                deleteIcon={<DownloadRoundedIcon sx={{ fontSize: 14 }} />}
                sx={{ maxWidth: 260, fontSize: 11, bgcolor: "#f8fafc", border: "1px solid #e2e8f0", cursor: "pointer" }}
            />
        </Box>
    );
}
